import React from 'react';
import Hero from '../../components/pages/About/Hero/Hero';
import Who from '../../components/pages/About/Who/Who';
import Purpose from '../../components/pages/About/Purpose/Purpose';
import Ceo from '../../components/pages/About/Ceo/Ceo';
import LookingForPartner from '../../components/pages/About/LookingForPartner/LookingForPartner';

const About = () => {
  return (
    <div>
      <Hero />
      <Who />
      <Purpose />
      <Ceo />
      <LookingForPartner />
    </div>
  );
};

export default About;
